'use client';

import { Link } from '@hc-frontend/core-ui';
import { usePathname, useSearchParams } from 'next/navigation';

import type { ClearFiltersLinkProps } from './clear-filters-link.types';

export function ClearFiltersLink({
  filterKeys,
  id,
  text,
  className,
  onClick,
}: ClearFiltersLinkProps) {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const params = new URLSearchParams(searchParams.toString());

  filterKeys.forEach((key) => {
    params.delete(key);
  });

  const href = `${pathname}?${params.toString()}`;

  return (
    <Link
      className={`hc-typography--help-text underline ${className}`}
      id={id}
      href={href}
      prefetch={false}
      replace
      onClick={onClick}
    >
      {text}
    </Link>
  );
}
